import { getWarnings } from '../RotaDrawer/components/DrawerStatus/utils'
import { useMemo } from 'react'
import { ClockInTeamMember } from '../types'

const useClockInWarnings = (warnings: ClockInTeamMember['warnings']) => {
  const clockInWarnings = useMemo(
    () => getWarnings(warnings),
    [warnings]
  )

  return clockInWarnings
}

export default useClockInWarnings
